import { useQuery } from '@tanstack/react-query';

import { fetchOffsetNotifications } from '../services';
import type { NotificationStatusFilter } from '../types';

type UseOffsetNotificationListParams = {
  page: number;
  pageSize: number;
  status: NotificationStatusFilter;
  agentId?: string;
};

export function useOffsetNotificationList(params: UseOffsetNotificationListParams) {
  const { page, pageSize, status, agentId } = params;

  return useQuery({
    queryKey: ['notifications', 'offset-list', page, pageSize, status, agentId],
    queryFn: () => {
      const is_read = status === 'read' ? true : status === 'unread' ? false : undefined;

      return fetchOffsetNotifications({
        limit: pageSize,
        offset: (page - 1) * pageSize,
        is_read,
        agent_id: agentId,
      });
    },
  });
}
